module.exports = __webpack_public_path__ + "media/images/countryrect/gd-8e0544584cc7cd6a68c6b39f0d7f5487.svg";